const facultyData = {
  hod: {
    id: "f-pranesh-kulkarni",
    name: "Mr. Pranesh Kulkarni",
    designation: "Assistant Professor & Head of Department",
    role: "Assistant Professor & Head of Department",
    qualification: "M.Tech.",
    qualifications: "M.Tech.",
    image: "/FacultyCImages/pranesh_kulkarni_CSE.jpeg",
    email: "hodcseds@klsvdit.edu.in, pkk@klsvdit.edu.in",
    phone: "+91 95387 23414",
    showPhone: false,
    experience: "10 years",
    description:
      "Mr. Pranesh Kulkarni has a decade of academic experience in the Dept. of CSE at KLS VDIT, Haliyal. He had taught various programming and analytical courses for UG students. He is AWS course instructor.",
    bio:
      "Mr. Pranesh Kulkarni has a decade of academic experience in the Dept. of CSE at KLS VDIT, Haliyal. He had taught various programming and analytical courses for UG students. He is AWS course instructor.",
    specializations: ["Machine Learning"],
    areas: ["Machine Learning"],
    courses: [
      "Machine Learning",
      "Object-Oriented Programming (OOP) With C++",
      "Cryptography",
    ],
    publications: 6,
    projects: 4,
    linkedin: "https://www.linkedin.com/in/pranesh-kulkarni-26bb84a0/",
    irins: "https://klsvdit.irins.org/profile/249274",
    recognition: [
      "Qualified University Grants Commission (UGC) National Eligibility Test (NET) for Assistant Professor in Computer Application",
      "Qualified Graduate Aptitude Test in Engineering (GATE) Data Science and Artificial Intelligence (DA) 2025",
      "Member of Association for Computing Machinery (ACM)",
      "Faculty Development Programme (FDP) Attended - 10",
      "International Conference Attended - 03",
    ],
  },
  members: [],
};

export default facultyData;
